import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const panelStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1.375rem;
	border-radius: ${theme.radii.xlarge};
	background-color: ${theme.colors.surface};
	border: 1.5px solid ${theme.colors.border};
`;

const titleStyle = css`
	${theme.typography.eyebrow}
	margin: 0;
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly title: string;
	readonly children: React.ReactNode;
};

/** The titled card of a dossier's information panel. */
const SubjectInformationPanel: React.FC<Props> = ({ title, children }) => {
	return (
		<section css={panelStyle} aria-label={title}>
			<h2 css={titleStyle}>{title}</h2>
			{children}
		</section>
	);
};

export default SubjectInformationPanel;
